// extracted by mini-css-extract-plugin
export default {"fastChart":"FastChart_fastChart__Ixqm7"};